import type { Channel } from 'belo-js-sdk';
import uniqBy from 'lodash.uniqby';

import type { DefaultBeloChatGenerics } from '../../types/types';

export const MAX_QUERY_CHANNELS_LIMIT = 30;

type MoveChannelUpParams<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = {
  channels: Array<Channel<BeloChatGenerics>>;
  cid: string;
  activeChannel?: Channel<BeloChatGenerics>;
};

export const moveChannelUp = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>({
  activeChannel,
  channels,
  cid,
}: MoveChannelUpParams<BeloChatGenerics>) => {
  // get index of channel to move up
  const channelIndex = channels.findIndex((channel) => channel.cid === cid);

  if (!activeChannel && channelIndex <= 0) return channels;

  // get channel to move up
  const channel = activeChannel || channels[channelIndex];

  return uniqBy([channel, ...channels], 'cid');
};
